'use strict';

var AppState = require('app_state');
var DeviceSelectView = require('components/devices/views/common/device_select_view');
var OOP = require('utils/oop');

module.exports = OOP.extend(
    DeviceSelectView,
    {
        initialize: function (options) {
            var deviceList = options.deviceList;
            options.itemsPerPage = AppState.getItemsPerPage();
            options.collection = deviceList.items;
            (options.listResult = deviceList.listResult),
                (options.itemCount = deviceList.count),
                (this.collection = options.collection);
            this.config = options.config;
            this.base.initialize(options);
            this.enableURLHistory = false;
        },

        getTableConfiguration: function () {
            var tableCfg = this.base.getTableConfiguration();

            tableCfg.CSVLink = undefined;
            tableCfg.customButtons = [];
            tableCfg.selectionButtons = [];
            tableCfg.isInModal = true;

            return tableCfg;
        },

        onBeforeRender: function () {
            var self = this;
            var config = this.config;

            if (this.base.onBeforeRender) {
                this.base.onBeforeRender();
            }

            config.selection.selectModels(this.collection.models);
            config.selection.update(this.collection.models, true);
        },

        rowSelected: function (e) {
            var result = this.base.rowSelected(e);
            this.config.selection.update(this.collection.models);

            return result;
        },
    },
    'WizardDeviceSelectView'
);
